import { render, staticRenderFns } from "./product-warranty-expired.vue?vue&type=template&id=1b0bc914"
import script from "./product-warranty-expired.vue?vue&type=script&lang=js"
export * from "./product-warranty-expired.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports